import React from 'react';
import { twMerge } from 'tailwind-merge';

import Icon from 'components/Misc/Icon';

const Section = ({ heading }) => {
	// Create section's class based on heading type
	const cls = twMerge(
		'flex items-center text-neutral-700 dark:text-white hover:text-amber-500 dark:hover:text-amber-500 transition-colors',
		heading.type === 'heading-two' && 'pl-4',
		heading.type === 'heading-three' && 'text-sm pl-9',
	);
	
	// Handle click on TOC section
	const onClick = event => {
		event.preventDefault();

		// Find element with heading's id
		const anchor = document.getElementById(heading.id);

		// Get element's offset
		const offset = anchor?.getBoundingClientRect();

		// Scroll smoothly to element
		window?.scroll({
			top: offset?.top - 70,
			behavior: 'smooth'
		});
	};

	return (
		<a
			href={`#${heading.id}`}
			onClick={onClick}
			className={cls}
		>
			<Icon icon="fiber_manual_record" className="mr-2 text-amber-500" />
			{heading.title}
		</a>
	);
};

export default Section;